<template>
	<div id="app">
		<div class="top-box">
			<div class="top-input">
				<div class="top-input-left" :style="{'width':width}">
					<img src="../assets/logo.png" alt="" />
				</div>
				<div class="top-input-right">
					<div class="marquee-box">
						<marquee behavior="scroll" direction="left" onMouseOut="this.start()" onMouseOver="this.stop()" scrollamount="20" scrolldelay="100" loop="-1">
							<span class="top-input-right-text">{{ title }}</span>
						</marquee>
					</div>
					<div class="header-rightBtnBox">
						<div class="btn-left" @click="fullScreen">
							<img v-if="isScreen" src="../assets/sx.png" alt="">
							<img v-else src="../assets/fd.png" alt="">
						</div>
						<div class="btn-right" @click="reSet">
							<img src="../assets/shuaxin.png" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="content-box">
			<div class="content-left-box" v-if="isUser">
				<div class="content-left-top-box">
					<div class="content-left-top-btn">
						<img src="../assets/wx.png" style="width: 0.31rem; margin-right: 0.13rem" alt="" />
						维修/安装/保养
					</div>
					<div class="content-left-top-title">
						<div>编号</div>
						<div>客户</div>
						<div>工位</div>
						<div>进度</div>
					</div>
					<div class="content-left-top-userList-box">
						<div class="repairBox">
							<div class="content-left-top-userList" :class="(i + 1) % 2 == 1 ? 'bgcPink' : ''" v-for="(item, i) in wxList" :key="i">
								<!-- <img src="../assets/vip.png" alt="" /> -->
								<div>{{ item.num }}</div>
								<div>
									{{ item.nickName }}
								</div>
								<div>{{ item.worker_station }}</div>
								<div>
									<li class="content-left-top-userList-listStyle">
										<span v-if="item.status==0">等待中</span>
										<span v-else-if="item.status==1">服务中</span>
										<span v-else-if="item.status==6">已派单</span>
										<span v-else-if="item.status==7">已接单</span>
										<span v-else-if="item.status==9">请到工位</span>
									</li>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="content-left-bottom-box">
					<div class="content-left-bottom-left">
						<div class="content-left-bottom-left-btn">
							<img src="../assets/qx.png" style="width: 0.31rem; margin-right: 0.13rem" alt="" />洗车
						</div>
						<div class="content-left-bottom-left-title">
							<div>编号</div>
							<div>客户</div>
							<div>工位</div>
							<div>进度</div>
						</div>
						<div class="content-left-bottom-userListLeft-box">
							<div class="clearBox">
								<div class="content-left-bottom-userListLeft clearBoxs" v-for="(item, i) in qxList" :class="(i + 1) % 2 == 1 ? 'bgcPink' : ''" :key="i">
									<div>{{ item.num }}</div>
									<div>{{ item.nickName }}</div>
									<div>{{ item.worker_station }}</div>
									<div>
										<li class="content-left-bottom-userListLeft-listStyle">
											<span v-if="item.status==0">等待中</span>
											<span v-else-if="item.status==1">服务中</span>
											<span v-else-if="item.status==6">已派单</span>
											<span v-else-if="item.status==7">已接单</span>
											<span v-else-if="item.status==9">请到工位</span>
										</li>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="content-left-bottom-right content-left-bottom-Two">
						<div class="content-left-bottom-right-btn">
							<img src="../assets/jy.png" style="width: 0.31rem; margin-right: 0.13rem" alt="" />救援/上门
						</div>
						<div class="content-left-bottom-right-title">
							<div>客户</div>
							<div>距离</div>
							<div>进度</div>
						</div>
						<div class="content-left-bottom-userListLeft-box">
							<div class="helptBox">
								<div class="content-left-bottom-userListLeft helptBoxs" :class="(i + 1) % 2 == 1 ? 'bgcPink' : ''" v-for="(item, i) in helpList" :key="i">
									<div>
										<div>{{ item.nickName }}</div>
									</div>
									<div>
										<div>
											{{
											  keepTwoDecimal(
											    !item.distance || item.distance == ''
											      ? 0
											      : item.distance / 1000
											  )
											}}km
										</div>
									</div>
									<div>
										<div>
											<span v-if="item.reserve_time==''">
												<span v-if="item.status == 0">等待中</span>
												<span v-else-if="item.status == 4">已出发</span>
												<span v-else-if="item.status == 5">已到达</span>
												<span v-else-if="item.status==6">已派单</span>
												<span v-else-if="item.status==7">已接单</span>
											</span>
											<span v-else-if="item.reserve_time!=''&&(item.status == 4||item.status == 5)">
												<span v-if="item.status == 0">等待中</span>
												<span v-else-if="item.status == 4">已出发</span>
												<span v-else-if="item.status == 5">已到达</span>
											</span>
											<span v-else>{{ item.reserve_time }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="content-left-bottom-right">
						<div class="content-left-bottom-right-btn">
							<img src="../assets/wait.png" style="width: 0.31rem; margin-right: 0.13rem" alt="" />等待取车
						</div>
						<div class="content-left-bottom-right-title">
							<div>编号</div>
							<div>客户</div>
						</div>
						<div class="content-left-bottom-userListLeft-box">
							<div class="waitBox">
								<div class="content-left-bottom-userListLeft waitBoxs" :class="(i + 1) % 2 == 1 ? 'bgcPink' : ''" v-for="(item, i) in qcList" :key="i">
									<div>{{ item.num }}</div>
									<div>{{ item.nickName }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="content-left-box content-left-boxTwo" v-else>
				<div class="content-left-top-box">
					<div class="content-left-top-btn">
						<img src="../assets/wx.png" style="width: 0.31rem; margin-right: 0.13rem" alt="" />
						维修/安装/保养
					</div>
					<div class="content-left-top-title">
						<div>人员工位</div>
						<div>客户编号</div>
						<div>状态</div>
					</div>
					<div class="content-left-top-userList-box">
						<div class="repairBox">
							<div class="content-left-top-userList" :class="(i + 1) % 2 == 1 ? 'bgcPink' : ''" v-for="(item, i) in wxList" :key="i">
								<div v-show="false">{{item.id}}</div>
								<!-- <img src="../assets/vip.png" alt="" /> -->
								<div>{{ item.realname }} {{item.worker_station}}</div>
								<div>
									{{ item.username }} {{item.num&&item.num!=0?item.num:''}}
								</div>
								<div>
									<li class="content-left-top-userList-listStyle">
										<span v-if="!item.status" style="color:#999">空闲中</span>
										<span v-else-if="item.status==0" style="color:#999">空闲中</span>
										<span v-else-if="[1,4,5].includes(item.status)" style="color: #5BB0E2;">服务中</span>
										<span v-else-if="item.status==6" style="color: #4EDB99;">已派单</span>
										<span v-else-if="item.status==7" style="color: #4EDB99;">已接单</span>
										<span v-else-if="item.status==9" style="color: #f03291">请到工位</span>
									</li>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="content-left-bottom-box">

					<div class="content-left-bottom-right content-left-bottom-Two">
						<div class="content-left-bottom-right-btn">
							<img src="../assets/jy.png" style="width: 0.31rem; margin-right: 0.13rem" alt="" />救援/上门
						</div>
						<div class="content-left-bottom-right-title">
							<div>客户</div>
							<div>距离</div>
							<div>状态</div>
						</div>
						<div class="content-left-bottom-userListLeft-box">
							<div class="helptBox">
								<div class="content-left-bottom-userListLeft helptBoxs" style="height: 20%;" :class="(i + 1) % 2 == 1 ? 'bgcPink' : ''" v-for="(item, i) in helpList" :key="i">
									<div v-show="false">{{item.id}}</div>
									<div>
										<div>
											{{ item.nickName }}
										</div>
									</div>
									<div>
										<div>
											{{keepTwoDecimal(!item.distance || item.distance == ''? 0: item.distance / 1000)}}km
										</div>
									</div>
									<div>
										<div>
											<span v-if="item.reserve_time==''||item.reserve_time==0">
												<span v-if="item.status == 0">等待中</span>
												<span v-else-if="item.status == 4">已出发</span>
												<span v-else-if="item.status == 5">已到达</span>
												<span v-else-if="item.status==6">已派单</span>
												<span v-else-if="item.status==7">已接单</span>
											</span>
											<span v-else-if="(item.reserve_time!=''||item.reserve_time==0)&&(item.status == 4||item.status == 5)">
												<span v-if="item.status == 0">等待中</span>
												<span v-else-if="item.status == 4">已出发</span>
												<span v-else-if="item.status == 5">已到达</span>
											</span>
											<span v-else>{{ item.reserve_time }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="content-left-bottom-right">
						<div class="content-left-bottom-right-btn">
							<img src="../assets/wait.png" style="width: 0.31rem; margin-right: 0.13rem" alt="" />等待取车
						</div>
						<div class="content-left-bottom-userListLeft-box">
							<div class="waitBox">
								<div class="waiUser-box" :class="{'waiUser-box-two':qcList.length>6}" v-for="(item, i) in qcList" :key="i">
									<div>
										{{item.nickName}} {{item.num}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="content-right-box">
				<div class="content-right-top">
					<div class="content-right-top-left">
						<div class="content-right-top-left-img">
							<img src="../assets/tq/dy.png" class="weatherPic" v-if="weatherType == '多云'" />
							<img src="../assets/tq/dayu.png" class="weatherPic" v-else-if="
                  weatherType == '小雨' ||
                  weatherType == '中雨' ||
                  weatherType == '大雨' ||
                  weatherType == '暴雨' ||
                  weatherType == '阵雨' ||
                  weatherType == '雷阵雨' ||
                  weatherType == '暴雨' ||
                  weatherType == '大暴雨' ||
                  weatherType == '特大暴雨'
                " />
							<img src="../assets/tq/dx.png" class="weatherPic" v-else-if="
                  weatherType == '小雪' ||
                  weatherType == '中雪' ||
                  weatherType == '大雪' ||
                  weatherType == '雨加雪' ||
                  weatherType == '暴雪'
                " />
							<img src="../assets/tq/qt.png" class="weatherPic" v-else-if="weatherType == '晴' || weatherType == '晴天'" />
							<img src="../assets/tq/yt.png" class="weatherPic" v-else-if="weatherType == '阴'" />

							<!-- <img src="../assets/xy.png" alt="" /> -->
						</div>
						<div class="content-right-top-left-text">
							{{ weatherType }}{{ weatherLow }}{{ weatherLow == '' ? '' : '-'
              }}{{ weatherHigh }}
						</div>
					</div>
					<div class="content-right-top-right">
						<div class="content-right-top-right-year">{{ times }}</div>
						<div class="content-right-top-right-time">{{ years }}</div>
					</div>
				</div>
				<div class="content-right-banner">
					<div class="about">
						<div class="swiper-container" v-if="bannerList.length > 1">
							<div class="swiper-wrapper">
								<div style="position: relative" class="swiper-slide" v-for="(item, i) in bannerList" :key="i" @click="showimg(item)">
									<video :src="item.video" v-if="item.type == 2" controls class="videos" autoplay ref="videos" @ended="endVideo(item)"></video>

									<img v-else :src="item.type == 2 ? item.cover : item.image" alt="" />

								</div>
							</div>
						</div>
						<div style="position: relative;width: 100%;height: 100%;" v-else-if="bannerList.length==1">
							<img :src="bannerList[0].image" alt="" v-if="bannerList[0].type == 1" style="width: 100%;height: 100%;" />
							<video :src="bannerList[0].video" v-if="bannerList[0].type == 2" controls autoplay class="videos" ref="video2" loop></video>
							<img class="clickVideo" src="../assets/open.png" style="width: 100%;height: 100%;" v-if="!ismuted && bannerList[0].type == 2" @click="ismuted = !ismuted" alt="" />
							<img class="clickVideo" src="../assets/close.png" style="width: 100%;height: 100%;" v-if="ismuted && bannerList[0].type == 2" @click="ismuted = !ismuted" alt="" />
						</div>
					</div>
				</div>
				<div class="content-right-address" style="min-height: 2.5vh">
					{{ infoObj.store_name }}
				</div>
				<div class="content-right-phoneNumber">
					全国客户服务热线：{{ infoObj.tel }}
				</div>
				<div class="content-right-erweima">
					<img :src="infoObj.qr_code" alt="" />
				</div>
				<div class="content-right-tops">扫码关注"爱玛服务"公众号</div>
				<div class="content-right-tops">
					随时随地查看排队进度，取车提醒，还有优惠福利等你来！
				</div>
			</div>
		</div>
		<!-- <img src="../assets/icon.png" class="boxIcon" alt="" /> -->
		<div id="allmap"></div>
		<a href="javascript:;"></a>
		<audio controls style="width: 200px;height: 200px;position: fixed;left: -99999px;top: -99999px;" id="audioBox" :src="url" type="audio/mpeg">
		</audio>
		<audio controls style="width: 200px;height: 200px;position: fixed;left: -99999px;top: -99999px;" :id="item.type" preload="auto" v-for="(item,i) in musicList" :src="item.url" type="audio/mpeg">
		</audio>
	</div>
</template>

<script>
	import Swiper from 'swiper';
	import { websocetObj } from '../../common/websocket.js';
	import { toggleFullscreen, isFullscreen } from '../../utils/tools.js';
	const synth = window.speechSynthesis;
	const msg = new SpeechSynthesisUtterance();
	// function changeObj(obj) {
	// 	obj.localService=true
	// 	return obj
	// }
	// setTimeout(()=>{
	// 	let array=synth.getVoices()
	// 	array.forEach(item=>{
	// 		item = changeObj(item)

	// 	})
	// },0)

	function setRem() {
		//  PC端
		let baseSize;
		// 基准大小
		baseSize = 100;
		let basePc = baseSize / 1920; // 表示1920的设计图,使用100PX的默认值
		let vW = window.innerWidth; // 当前窗口的宽度
		let rem = vW * basePc; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应font-size值
		let logo = document.querySelector('.top-input-left')
		document.documentElement.style.fontSize = rem + 'px';
		let about = document.querySelector('.about')
		let banner = document.querySelector('.content-right-banner')
		if (banner) {
			about.style.width = '100%'
			about.style.width = parseInt(banner.offsetWidth) + 'px'
			let num = banner.offsetWidth / 16 * 9
			banner.style.height = num + 'px'
		}
		if (logo) {
			logo.style.width = parseInt(logo.offsetHeight) / 0.31 + 'px'
			// console.log(logo.offsetHeight)
		}

	}
	// 初始化
	setRem();
	// 改变窗口大小时重新设置 rem
	window.onresize = function() {
		setRem();
	};

	export default {
		name: 'indexHome',
		props: {
			msg: String,
		},
		data() {
			return {
				counter: 0,
				years: '',
				times: '',
				getTime: null,
				wxList: [],
				qxList: [],
				qcList: [],
				musicList: [{
						url: 'https://aimachefu.oss-cn-beijing.aliyuncs.com/images/banner/2022/06/20/180627/e392fcf6c11c75fa729a47337ff3e1c3.mp3',
						type: 'jiuyuan'
					},
					{
						url: 'https://aimachefu.oss-cn-beijing.aliyuncs.com/images/banner/2022/06/20/180638/02ec12f0b1f4bec3e7acfe1f137db377.mp3',
						type: 'shangmen'
					},
					{
						url: 'https://aimachefu.oss-cn-beijing.aliyuncs.com/images/banner/2022/06/20/180607/f878d3b38ad137ecdcb00f1145ae6091.mp3',
						type: 'daodian'
					}
				],
				helpList: [],
				bannerList: [],
				swipers: {},
				weatherHigh: '',
				weatherLow: '',
				weatherType: '',
				infoObj: {},
				time1: false,
				time2: false,
				time3: false,
				time4: false,
				title: '爱玛电动车，爱就马上行动！',
				time: false,
				city: '',
				allScroll1: 0,
				allScroll2: 0,
				allScroll3: 0,
				allScroll4: 0,
				ismuted: true,
				textArray: [
					'凡事不要自我设限，凡事皆有可能。',
					'不要做幻想的乞丐，要做幸福的创造者。',
					'奋斗没有终点，任何时候都是一个起点。',
					'每天的太阳都是新的，不要辜负了美好的晨光。',
					'有目标的人生才有方向有规划的人生才更精彩。'
				],
				autoplay: false,
				wxList2: [],
				qxList2: [],
				qcList2: [],
				helpList2: [],
				token: '',
				getListTime: '',
				showBox: true,
				bobaoList: [],
				titles: '',
				listObj: {},
				videoEnd: null,
				url: '',
				musicNumber: 0.4,
				muteds: false,
				changeTypeTime: [], //定时查找救援单状态是否更新列表
				setTimeOutVideo: null,
				isScreen: false, //是否全屏
				width: '0px',
				isUser: true,
				maxListNumber: 5,
				minListNumber: 4,
				subTimeInaval: null
			};
		},
		watch: {
			"$store.state.orderType": function(val, old) {
				this.getAllList()
			},
			"$store.state.boxShow": function(val, old) {
				clearInterval(this.subTimeInaval)
				this.subTimeInaval = null
				this.wxList = []
				this.qxList = []
				this.qcList = []
				this.helpList = []
				this.bobaoList = []
				this.titles = ''

				this.title = '爱玛电动车，爱就马上行动！'
				this.getNewList('爱玛电动车，爱就马上行动！')

				let html = `<div class='bigBox' >此大屏被其他人打开 <br />
		 <div class='pinktext'>如需重新登录请刷新页面 </div> </div> `
				this.$alert(`${html}`, ``, {
					showClose: false,
					confirmButtonClass: true,
					confirmButtonText: '确定',
					dangerouslyUseHTMLString: true,
					confirmButtonClass: 'sureBtn',
					callback: action => {

					}
				});
			}
		},
		created() {

			let that = this
			that.isAll()
			that.url = that.changeSrc()
			this.$bus.$on('changeList', (res) => {
				// console.log(22222)
			})
			this.$bus.$on('againSoket', (res) => {
				// console.log(232323)
				that.bobaoList = []
				that.getNewList('爱玛电动车，爱就马上行动！')
				that.getAllList()
			})
			// that.$store.dispatch('websocketClose')


		},

		mounted() {
			let that = this
			let body = document.querySelector('.top-input-left')
			let height = body.offsetHeight
			this.width = height / 0.31 + 'px'
			let num = Math.floor(Math.random() * (4 - 0 + 1)) + 0;
			// console.log(num)
			let html = `<img src="${require('../assets/icons.png')}" \>` + that.textArray[num]
			this.$alert(`${html}`, ``, {
				showClose: false,
				confirmButtonClass: true,
				confirmButtonText: '确定',
				dangerouslyUseHTMLString: true,
				confirmButtonClass: 'sureBtn',
				callback: action => {
					this.getToken()
					setRem()
				}
			});
			let audio = document.getElementById('audioBox')
			let jiuyuanAudio = document.getElementById('jiuyuan')
			let shangmenAudio = document.getElementById('shangmen')
			let daodianAudio = document.getElementById('daodian')
			audio.addEventListener('play', () => {
				that.handleAudioPlay()
			})
			audio.addEventListener('ended', () => {
				that.handleAudioEnd()
			})
			jiuyuanAudio.addEventListener('play', () => {
				that.handleAudioPlay()
			})
			jiuyuanAudio.addEventListener('ended', () => {
				that.handleAudioEnd()
			})
			shangmenAudio.addEventListener('play', () => {
				that.handleAudioPlay()
			})
			shangmenAudio.addEventListener('ended', () => {
				that.handleAudioEnd()
			})
			daodianAudio.addEventListener('play', () => {
				that.handleAudioPlay()
			})
			daodianAudio.addEventListener('ended', () => {
				that.handleAudioEnd()
			})
		},
		methods: {
			//上报时间
			async escalationTime() {
				let that = this
				let formDate = new FormData();
				formDate.append(
					'store_code',
					'' + window.location.href.split('store_code').length > 1 ?
					window.location.href.split('store_code')[1].slice(1) :
					''
				);
				formDate.append('sign', '73kdUKDRPL^#)_)(98.,xdfji');
				formDate.append('sysnum_token', that.token);
				const { data: res } = await that.$http.post('/sysnum/systemnumber/add_screen_log', formDate)

				console.log(res)
			},
			reSet() {
				window.location.href = window.location.href
			},
			//全屏按钮
			fullScreen() {
				try {
					this.isScreen = toggleFullscreen();
				} catch (e) {
					// this.$message.error('您的浏览器不支持全屏模式');
				}
			},
			//是否全屏
			isAll() {
				this.isScreen = isFullscreen()
			},
			//查找是否有订单状态未更新
			async queryTypeChange(list) {
				let that = this
				let orderList = list.map(item => {
					return item.orderSn
				})
				const { data: res } = await this.$http.post('/sysnum/systemnumber/check_orders', {
					orderSn: orderList
				})
				if (res == 1) {
					that.getAllList()
				}
			},
			handleAudioPlay() {
				let that = this
				let videos = document.querySelectorAll('.videos')
				let isMuted = JSON.parse(JSON.stringify(that.muteds))
				videos.forEach(item => {

					item.muted = true

				})
				setTimeout(() => {
					that.muteds = isMuted
				}, 0)
			},
			handleAudioEnd() {
				let that = this
				if (that.bobaoList.length > 0) {
					let strIndex = that.bobaoList.indexOf(that.titles)
					let str = JSON.parse(JSON.stringify(that.bobaoList[strIndex]))
					that.bobaoList.splice(strIndex, 1)
					let index = str.indexOf('您有一个新的救援订单')
					let indexs = str.indexOf('您有一个新的上门订单')
					// console.log(index,indexs)
					if (index > -1 || indexs > -1) {
						that.bobaoList.push(str)
					}
					// console.log( that.bobaoList)
					let indexTime = that.bobaoList.findIndex(item => item.indexOf('您有一个新的救援订单') <= -1 && item.indexOf('您有一个新的上门订单') <= -1)
					if (that.bobaoList.length <= 0) {
						that.getNewList('爱玛电动车，爱就马上行动！')
						let videos = document.querySelectorAll('.videos')
						videos.forEach(item => {
							item.muted = that.muteds
							item.volume = that.musicNumber
						})
					} else {
						that.getNewList(that.bobaoList[0])
					}
				} else {
					that.getNewList('爱玛电动车，爱就马上行动！')
					let videos = document.querySelectorAll('.videos')
					videos.forEach(item => {
						item.muted = that.muteds
						item.volume = that.musicNumber
					})
				}
			},
			urlencode(str) {
				str = (str + '').toString();
				return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
			},

			changeSrc(text) {
				if (!text) {
					return false
				}
				let formDate = new FormData();
				formDate.append(
					'store_code',
					'' + window.location.href.split('store_code').length > 1 ?
					window.location.href.split('store_code')[1].slice(1) :
					''
				);
				formDate.append('sign', '73kdUKDRPL^#)_)(98.,xdfji');
				formDate.append('sysnum_token', this.token);
				let str = text
				str = str.replace('1', '衣')
				str = str.replace('2', '二')
				str = str.replace('3', '叁')
				str = str.replace('4', '寺')
				str = str.replace('5', '舞')
				str = str.replace('6', '六')
				str = str.replace('7', '期')
				str = str.replace('8', '巴')
				str = str.replace('9', '久')
				str = str.replace('0', '陵')
				let msg = this.urlencode(str)
				formDate.append('content', str);
				// https://fanyi.sogou.com/reventondc/synthesis?text=%E4%BD%A0%E5%A5%BD%E5%95%8A&speed=1&lang=zh-CHS&from=translateweb&speaker=6
				// let src = 'https://fanyi.sogou.com/reventondc/synthesis?text=' + msg + '&speed=1&lang=zh-CHS&from=translateweb&speaker=6'
				return new Promise(async (resove, reject) => {
					let { data: res } = await this.$http.post('/sysnum/systemnumber/tts', formDate)
					let url = 'data:video/mp4;base64,'
					if (res.status == 1) {
						url = url + res.data
					}
					resove(url)
				})
			},
			async getAllList() {
				let that = this
				let formDate = new FormData();
				formDate.append(
					'store_code',
					'' + window.location.href.split('store_code').length > 1 ?
					window.location.href.split('store_code')[1].slice(1) :
					''
				);
				formDate.append('sign', '73kdUKDRPL^#)_)(98.,xdfji');
				formDate.append('sysnum_token', this.token);
				const { data: res } = await this.$http.post('/sysnum/systemnumber/number_list', formDate)
				if (res.status == 1) {
					that.isUser = res.data.sort_type == 1
					that.maxListNumber = res.data.sort_type == 1 ? 5 : 10
					that.minListNumber = res.data.sort_type == 1 ? 4 : 5
					//维修
					console.log(res)
					this.changeWx(res.data.sort_type == 1 ? res.data.weixiu : res.data.worker_list)
					//救援
					this.changeHelp(res.data.jiuyuan)
					//清洗保护
					this.changeQx(res.data.xiche)
					//取车
					this.changeQc(res.data.quche)

					//处理语音播报
					this.listObj = res.data
					this.changeBobaoList(res.data)
					res.data.jiuyuan.forEach(item => {
						that.changeTypeTime.forEach((obj, i) => {
							if (item.orderSn == obj.orderSn) {
								if (item.worker_id > 0) {
									clearInterval(obj.timer)
									obj.timer = null
									that.changeTypeTime.splice(i, 1)
								}
							}

						})
					})
					that.changeTypeTime.forEach((item, i) => {
						let orderList = res.data.jiuyuan.filter((ject) => {
							return ject.orderSn == item.orderSn
						})
						if (orderList.length == 0) {
							clearInterval(item.timer)
							item.timer = null
							that.changeTypeTime.splice(i, 1)
						}
					})
					let jiuyuan = res.data.jiuyuan.filter(item => {
						return item.worker_id <= 0 || item.worker_id == '' || !item.worker_id
					})
					let changeTypeList = JSON.parse(JSON.stringify(that.changeTypeTime))
					jiuyuan.forEach(item => {
						let orderList = changeTypeList.filter(obj => {
							return obj.orderSn == item.orderSn
						})
						if (orderList.length == 0) {
							item.timer = setInterval(() => {
								that.queryTypeChange(item.orderSn)
							}, 60000)
							that.changeTypeTime.push(item)
						}
					})
				} else {
					// this.showBox=false
					this.$store.commit('changeBoxShow', false)
					this.bobaoList = []
					clearInterval(this.subTimeInaval)
					this.subTimeInaval = null
				}
			},

			//处理维修列表或者员工列表
			changeWx(list) {
				list.forEach(item => {
					if (item.tel) {
						let num = item.tel.slice(item.tel.length - 4, item.length)
						if (!item.username) {
							item.nickName = '尾号' + num
						} else {
							item.nickName = item.username
						}
					}

				})
				if (this.wxList.length == 0) {
					this.wxList = list
					this.wxList2 = list
				} else {
					if (this.wxList.length <= this.maxListNumber) {
						this.wxList = list
						this.wxList2 = list
					} else if (this.wxList.length > this.maxListNumber) {
						this.wxList2 = list
					}
				}
				if (this.wxList.length > this.maxListNumber) {
					this.animateFn(
						'repairBox',
						'.content-left-top-userList:first',
						1,
						this
					);
				} else {
					clearInterval(this.timer1);
				}
			},
			//处理清洗
			changeQx(list) {
				list.forEach(item => {

					let num = item.tel.slice(item.tel.length - 4, item.length)
					if (!item.username) {
						item.nickName = '尾号' + num
					} else {
						item.nickName = item.username
					}
				})
				if (this.qxList.length == 0) {
					this.qxList = list
					this.qxList2 = list
				} else {
					if (this.qxList.length <= this.minListNumber) {
						this.qxList = list
						this.qxList2 = list
					} else if (this.qxList.length > this.minListNumber) {
						this.qxList2 = list
					}
				}
				if (this.qxList.length > this.minListNumber && this.isUser) {
					this.animateFn(
						'clearBox',
						'.content-left-bottom-userListLeft:first',
						2,
						this
					);
				} else {
					clearInterval(this.timer2);
				}
			},
			//处理救援
			changeHelp(list) {
				list.forEach(item => {

					let num = item.tel.slice(item.tel.length - 4, item.length)
					if (!item.username) {
						item.nickName = '尾号' + num
					} else {
						item.nickName = item.username
					}
				})
				if (this.helpList.length == 0) {
					this.helpList = list
					this.helpList2 = list
				} else {
					if (this.helpList.length <= this.minListNumber) {
						this.helpList = list
						this.helpList2 = list
					} else if (this.helpList.length > this.minListNumber) {
						this.helpList2 = list
					}
				}
				if (this.helpList.length > this.minListNumber) {
					this.animateFn(
						'helptBox',
						'.content-left-bottom-userListLeft:first',
						4,
						this
					);
				} else {
					clearInterval(this.timer4);
				}
			},
			//处理取车
			changeQc(list) {
				list.forEach(item => {
					let num = item.tel.slice(item.tel.length - 4, item.length)
					if (!item.username) {
						item.nickName = '尾号' + num
					} else {
						item.nickName = item.username
					}
				})
				if (this.qcList.length == 0) {
					this.qcList = list
					this.qcList2 = list
				} else {
					if (this.qcList.length <= this.minListNumber) {
						this.qcList = list
						this.qcList2 = list
					} else if (this.qcList.length > this.minListNumber) {
						this.qcList2 = list
					}
				}
				if (this.qcList.length > this.minListNumber && this.isUser) {
					this.animateFn(
						'waitBox',
						'.content-left-bottom-userListLeft:first',
						3,
						this
					);
				} else {
					clearInterval(this.timer3);
				}
			},
			//处理语音播报数组
			async changeBobaoList(obj) {
				let jy = obj.jiuyuan.filter(item => {
					return item.worker_id <= 0
				})

				let qc = obj.quche.filter(item => {
					return item.is_bo != 2
				})

				let wx = obj.weixiu.filter(item => {
					return item.is_bo == 0 //0首次播放 1不播
				})

				let wx2 = obj.weixiu.filter(item => {
					return item.is_bo == 3 //0首次播放 1不播 3二次播放
				})

				let qx = obj.xiche.filter(item => {
					return item.is_bo == 0
				}) //首次爆单

				let qx2 = obj.xiche.filter(item => {
					return item.is_bo == 3
				}) //点击叫号

				this.boBaoListFiterTwo(jy)
				this.boBaoListFiter(qc, 2)
				this.boBaoListFiter(qx2, 1)
				this.boBaoListFiter(wx2, 1)
				this.boBaoListFiter(qx, 3)
				this.boBaoListFiter(wx, 3)
				setTimeout(() => {
					let audio = document.getElementById('audioBox')
					let jiuyuanAudio = document.getElementById('jiuyuan')
					let shangmenAudio = document.getElementById('shangmen')
					let daodianAudio = document.getElementById('daodian')
					if (this.bobaoList.length > 0 && audio.paused && jiuyuanAudio.paused && shangmenAudio.paused && daodianAudio.paused) {
						this.getNewList(this.bobaoList[0])
					}
				}, 0)
			},
			//处理播报过滤
			boBaoListFiter(list, type) {
				let that = this
				return new Promise((resolve, reject) => {
					if (type == 1) {
						list.forEach(item => {
							let num = item.tel.slice(item.tel.length - 4, item.length)
							let arr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
							let str = ''
							let numList = num.split('')
							numList.forEach(res => {
								str = str + arr[res - 0]
							})
							if (item.worker_station) {

								let strs = '请手机尾号为' + str + '的车主到' + item.worker_station + '号工位'
								if (item.username) {
									strs = "请" + item.username + '到' + item.worker_station + '号工位'
								}
								let index = this.bobaoList.indexOf(strs)
								if (index < 0) {
									this.bobaoList.unshift(strs)
								}

							} else {
								let strs = '请手机尾号为' + str + '的车主到' + '工位'
								if (item.username) {
									strs = "请" + item.username + '到工位'
								}
								let index = this.bobaoList.indexOf(strs)
								if (index < 0) {
									this.bobaoList.unshift(strs)
								}
							}

						})
					} else if (type == 3) {
						list.forEach(item => {
							let strs = '您有一个新的到店订单,请服务小哥快来接单吧!'
							let index = this.bobaoList.indexOf(strs)
							if (index < 0) {
								this.bobaoList.unshift(strs)
							}
						})
					} else {
						list.forEach(item => {

							let num = item.tel.slice(item.tel.length - 4, item.length)
							let arr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
							let str = ''

							let numList = num.split('')
							numList.forEach(res => {
								str = str + arr[res - 0]
							})
							let text = '尾号' + str + '的车主'
							let strs = text + ',您的车已准备好,请您取车。'
							if (item.username) {
								strs = item.username + ',您的车已准备好,请您取车。'
							}
							let index = this.bobaoList.indexOf(strs)
							if (index < 0) {
								this.bobaoList.unshift(strs)
							}
						})
						if (list.length > 0) {
							setTimeout(() => {
								that.getAllList()
							}, 60000)
						}
					}
					resolve()
				})
			},
			boBaoListFiterTwo(list) {
				return new Promise((resolve, reject) => {
					list.forEach(item => {
						if (item.serve_type == 2) {
							let strs = '您有一个新的救援订单,请服务小哥快来接单吧!'
							let index = this.bobaoList.indexOf(strs)
							if (index < 0) {
								this.bobaoList.push(strs)
							}
						} else if (item.serve_type == 3) {
							let strs = '您有一个新的上门订单,请服务小哥快来接单吧!'
							let index = this.bobaoList.indexOf(strs)
							// console.log(index)
							if (index < 0) {
								this.bobaoList.push(strs)
							}
						}
					})
					let jy = list.filter(item => {
						return item.serve_type == 2
					})
					let sm = list.filter(item => {
						return item.serve_type == 3
					})
					if (jy.length <= 0) {
						let strs = '您有一个新的救援订单,请服务小哥快来接单吧!'
						let index = this.bobaoList.indexOf(strs)
						// console.log(index)
						if (index >= 0) {
							this.bobaoList.splice(index, 1)
						}
						// console.log(this.bobaoList)
					}
					if (sm.length <= 0) {
						let strs = '您有一个新的上门订单,请服务小哥快来接单吧!'
						let index = this.bobaoList.indexOf(strs)
						if (index >= 0) {
							this.bobaoList.splice(index, 1)
						}
					}
				})
				resolve()
			},
			async getToken() {
				let that = this
				let formDate = new FormData();
				formDate.append(
					'store_code',
					'' + window.location.href.split('store_code').length > 1 ?
					window.location.href.split('store_code')[1].slice(1) :
					''
				);
				const { data: res } = await this.$http.post('/sysnum/systemnumber/getToken', formDate)
				if (res.status == 1) {
					that.token = res.data.sysnum_token
					that.$store.state.socketType == 1 ? websocetObj.sokcet() : that.$store.dispatch('websocketInit', res.data.sysnum_token);
					clearInterval(this.subTimeInaval)
					this.subTimeInaval = null
					this.subTimeInaval = setInterval(() => {
						that.escalationTime()
					}, 300000)

					this.getDate();
					this.getWeather();
					this.getIsBo();
					that.getTime = setInterval(() => {
						let myDate = new Date();
						let year = myDate.getFullYear();
						let month = myDate.getMonth() - 0 + 1;
						let day = myDate.getDate();
						let hour = myDate.getHours();
						let minute = myDate.getMinutes();
						let second = myDate.getSeconds();
						let a;
						let b;
						let c;
						let d;
						month < 10 ? (a = '0' + month) : (a = month);
						day < 10 ? (b = '0' + day) : (b = day);
						hour < 10 ? (c = '0' + hour) : (c = hour);
						minute < 10 ? (d = '0' + minute) : (d = minute);
						that.times = c + ':' + d;
						that.years = year + '-' + a + '-' + b;
						if (hour == '00' && minute == '00') {
							if (second >= '0' && second <= 1) {
								that.getWeather();
							}
						}
					}, 1000);

					this.$nextTick(() => {
						document.addEventListener(
							'plusready',
							function() {

							},
							false
						);
						let banner = document.querySelector('.content-right-banner')
						if (banner) {
							let num = banner.offsetWidth / 16 * 9
							banner.style.height = num + 'px'
						}
					})
				}

			},
			fomatDate(obj) {
				if (obj == 0) {
					return ''
				} else if (obj == '' || !obj) {
					return ''
				} else {
					let myDate = Date.now();
					let num = obj * 1000
					let myDates = new Date(obj * 1000)
					// console.log(myDates)
					let month = myDates.getMonth() - 0 + 1;
					let day = myDates.getDate();
					let hour = myDates.getHours();
					let minute = myDates.getMinutes();
					// console.log(myDate)
					month = month < 10 ? '0' + month : month
					day = day < 10 ? '0' + day : day
					hour = hour < 10 ? '0' + hour : hour
					minute = minute < 10 ? '0' + minute : minute
					if (((obj * 1000) - myDate) < (10 * 60 * 1000)) {
						return ''
					} else {
						return month + '-' + day + ' ' + hour + ':' + minute
					}
				}
			},
			keepTwoDecimal(num) {
				var result = parseFloat(num);
				if (isNaN(result)) {
					return false;
				}
				result = Math.round(num * 100) / 100;
				return result;
			},
			async getIsBo() {
				let formDate = new FormData();
				formDate.append(
					'store_code',
					'' + window.location.href.split('store_code').length > 1 ?
					window.location.href.split('store_code')[1].slice(1) :
					''
				);

				const { data: res } = await this.$http.post(
					'/num/systemnumber/store_info',
					formDate
				);
				if (res.status == 1) {
					this.infoObj = res.data;
				}
			},
			getIp() {

			},
			async getWeather(city) {
				let formDate = new FormData();
				formDate.append(
					'store_code',
					'' + window.location.href.split('store_code').length > 1 ?
					window.location.href.split('store_code')[1].slice(1) :
					''
				);
				formDate.append(
					'sign',
					'73kdUKDRPL^#)_)(98.,xdfji'
				);
				formDate.append('sysnum_token', this.token);
				const { data: res } = await this.$http.post('/sysnum/systemnumber/weather', formDate);
				if (res.status == 1) {
					this.weatherHigh = res.data.forecast[0].high.split(' ')[1];
					this.weatherLow = res.data.forecast[0].low.split(' ')[1];
					this.weatherType = res.data.forecast[0].type;
				}
			},
			reset() {
				clearInterval(this.time1);
				this.time1 = null;
				this.allScroll1 = 0;
				clearInterval(this.time2);
				this.time2 = null;
				this.allScroll2 = 0;
				clearInterval(this.time3);
				this.time3 = null;
				this.allScroll3 = 0;
				clearInterval(this.time4);
				this.time4 = null;
				this.allScroll4 = 0;
			},
			getNewList(title) {
				let that = this
				// console.log(title)
				clearTimeout(this.time);
				// this.reset();
				this.title = title;
				this.titles = title
				let index = title.indexOf('尾号')
				if (index >= 0) {
					let arr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
					let str = ''
					let numList = title.split('')
					numList.forEach(res => {
						let indexs = arr.indexOf(res)
						if (indexs >= 0) {
							str = str + indexs
						} else {
							str = str + res
						}
					})
					this.title = str
					// console.log(str)
					this.title = str
				}

				document.querySelector('.marquee-box').innerHTML = `<marquee
            behavior="scroll"
            direction="left"
            onMouseOut="this.start()"
            onMouseOver="this.stop()"
            scrollamount="20"
            scrolldelay="100"
            loop="-1"
          >
            <span class="top-input-right-text">${this.title}</span>
          </marquee>`;
				if (title == '您有一个新的到店订单,请服务小哥快来接单吧!') {
					let audio = document.getElementById('daodian')
					audio.play()
				} else if (title == '您有一个新的救援订单,请服务小哥快来接单吧!') {
					let audio = document.getElementById('jiuyuan')
					audio.play()
				} else if (title == '您有一个新的上门订单,请服务小哥快来接单吧!') {
					let audio = document.getElementById('shangmen')
					audio.play()
				} else if (title != '爱玛电动车，爱就马上行动！') {
					that.changeSrc(title).then(res => {
						let audio = document.getElementById('audioBox')
						audio.src = res
						audio.play()
					})

				}


			},
			playVoice(text) {
				// console.log(text)
				this.handleSpeak(text); // 传入需要播放的文字
			},
			// 语音播报的函数
			handleSpeak(text) {
				msg.text = text; // 文字内容: 小朋友，你是否有很多问号
				msg.lang = 'zh-CN'; // 使用的语言:中文
				msg.volume = 1; // 声音音量：1
				msg.rate = 1; // 语速：1
				msg.pitch = 1; // 音高：1

				synth.speak(msg); // 播放
			},
			// 语音停止
			handleStop(e) {
				msg.text = e;
				msg.lang = 'zh-CN';
				synth.cancel(msg);
			},
			showimg(obj) {

			},

			endVideo(obj) {
				obj.beginShow = false;

			},
			getDate() {
				let myDate = new Date();
				let year = myDate.getFullYear();
				let month = myDate.getMonth() - 0 + 1;
				let day = myDate.getDate();
				let hour = myDate.getHours();
				let minute = myDate.getMinutes();
				this.times =
					(hour < 10 ? '0' + hour : hour) +
					':' +
					(minute < 10 ? '0' + minute : minute);
				this.years =
					year +
					'-' +
					(month < 10 ? '0' + month : month) +
					'-' +
					(day < 10 ? '0' + day : day);
				this.getAllList()
				this.getBannerList();
			},

			async getBannerList() {
				let that = this
				let formDate = new FormData();
				formDate.append(
					'store_code',
					'' + window.location.href.split('store_code').length > 1 ?
					window.location.href.split('store_code')[1].slice(1) :
					''
				);
				formDate.append('sign', '73kdUKDRPL^#)_)(98.,xdfji');
				formDate.append('sysnum_token', this.token);
				const { data: res } = await this.$http.post(
					'/num/systemnumber/get_banner',
					formDate
				);
				if (res.status == 1) {
					let newArray = [];
					for (let key in res.data) {
						newArray.push(res.data[key]);
					}
					this.bannerList = newArray.map((item) => {
						item.beginShow = false;
						return item;
					});
					this.$nextTick(() => {

						if (this.bannerList.length == 1) {
							let videos = document.querySelector('.videos');
							// this.$refs.video2.play();
							if (videos) {
								videos.currentTime = 0
								videos.volume = this.musicNumber
								videos.muted = this.muteds
								videos.play()
								videos.loop = true
							}
						}
						let mySwiper = new Swiper('.swiper-container', {
							loop: true,
							// 如果需要分页器
							// pagination: '.swiper-pagination',
							// 如果需要前进后退按钮
							// nextButton: '.swiper-button-next',
							// prevButton: '.swiper-button-prev',
							// 如果需要滚动条
							// scrollbar: '.swiper-scrollbar',
							//如果需要自动切换海报
							// sautoplayDisableOnInteraction:false,
							autoplay: 3000,
							observer: true,
							observeParents: true,
							// onTouchMove:(res)=>{
							// 	that.swipers.stopAutoplay();
							// },
							// onTouchEnd:(res)=>{
							// 	// that.swipers.stopAutoplay();
							// 	that.swipers.startAutoplay();
							// },
							onSlideChangeEnd: (res) => {
								let num = res.activeIndex - 1;
								let videos = document.querySelectorAll('.videos');
								videos.forEach(item => {
									item.muted = that.muteds
									item.pause()
									item.currentTime = 0
									item.volume = that.musicNumber
								})
								if (res.activeIndex > this.bannerList.length) {
									num = 0;
								}
								if (num < 0) {
									num = 0;
								}
								let nums = res.activeIndex - 2
								if (nums < 0) {
									nums = 0
								}

								if (num >= 0) {

									if (this.bannerList[num].type == 2) {

										setTimeout(() => {
											setTimeout(() => {
												let videos = document.querySelectorAll('.videos');
												let list = document.querySelectorAll('.swiper-slide');
												if (list.length > 0) {
													this.swipers.stopAutoplay();
													list[res.activeIndex].children[0].currentTime = 0
													if (list[res.activeIndex].children[0].localName != 'video') {
														return
													}
													list[res.activeIndex].children[0].play()

													let fn1 = function(e) {
														that.muteds = e.target.muted
														that.musicNumber = e.target.volume
													}
													list[res.activeIndex].children[0].removeEventListener('volumechange', fn1, false)
													let fn = function() { //结束
														list[res.activeIndex].children[0].removeEventListener('ended', fn, false)
														that.swipers.startAutoplay();
													}
													list[res.activeIndex].children[0].addEventListener('ended', fn, false);
													list[res.activeIndex].children[0].addEventListener('volumechange', fn1, false);
												}

											}, 100);
										}, 500);
									} else {
										this.bannerList[num].beginShow = false;

										setTimeout(() => {
											this.swipers.startAutoplay();
										}, 500);
									}
								}
							},
						});
						this.swipers = mySwiper;
					});
				}
			},

			animateFn(obj, list, type) {
				var $uList = $('.' + obj);
				let that = this;
				if (type == 1) {
					clearInterval(that.timer1);
					if (!that.time1) {
						that.time1 = setInterval(function() {
							scrollList($uList, that.allScroll1);
						}, 2000);
					}
				} else if (type == 2) {
					clearInterval(that.timer2);
					if (!that.time2) {
						that.time2 = setInterval(function() {
							scrollList($uList, that.allScroll2);
						}, 2000);
					}
				} else if (type == 3) {
					if (that.timer3) {
						clearInterval(that.timer3);
					}

					if (!that.time3) {
						that.time3 = setInterval(function() {
							scrollList($uList, that.allScroll3);
						}, 2000);
					}
				} else {
					clearInterval(that.timer4);
					if (!that.time4) {
						that.time4 = setInterval(function() {
							scrollList($uList, that.allScroll4);
						}, 2000);
					}
				}
				$uList
					.hover(
						// function () {
						// },
						function() {
							//离开启动定时器
						}
					)
					.trigger('mouseleave'); //自动触发触摸事件

				function scrollList(obj, scroll) {
					var scrollHeight = $(list).height();
					// console.log(type)
					if (type == 1) {
						let list = document.querySelectorAll('.content-left-top-userList')
						let str = list[0].innerText.split('\n')[0]
						let num = that.wxList[0].num
						if (!that.isUser) {
							str = list[0].children[0].innerHTML
							num = that.wxList[0].id
						}
						if (list.length > 0 && str == num) {
							that.wxList = that.wxList2
							if (that.wxList.length <= that.maxListNumber) {
								clearInterval(that.time1);
								that.time1 = ''
								return
							}
						}
					}
					if (type == 2) {
						let list = document.querySelectorAll('.clearBoxs')
						if (list.length > 0 && list[0].innerText.split('\n')[0] == that.qxList[0].num) {
							that.qxList = that.qxList2
							if (that.qxList.length <= that.minListNumber) {
								clearInterval(that.time2);
								that.time2 = ''
								return
							}
						}
					}
					if (type == 3) {
						let list = document.querySelectorAll('.waitBoxs')
						if (list.length > 0 && list[0].innerText.split('\n')[0] == that.qcList[0].num) {
							that.qcList = that.qcList2
							if (that.qcList.length <= that.minListNumber) {
								clearInterval(that.time3);
								that.time3 = ''
								return
							}
						}
					}
					if (type == 4) {
						let list = document.querySelectorAll('.helptBoxs')
						if (list.length > 0 && list[0].children[0].innerHTML == that.helpList[0].id) {
							that.helpList = that.helpList2
							if (that.helpList.length <= this.minListNumber) {
								clearInterval(that.time4);
								that.time4 = ''
								return
							}
						}
					}
					$uList.stop().animate({
							marginTop: -(scroll + scrollHeight),
						},
						1000,
						function() {
							$uList.css({ marginTop: 0 }).find(list).appendTo($uList);
						}
					);
				}
			},
		},
		beforeDestroy() {
			clearInterval(this.getTime);
			this.reset();
		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	h3 {
		margin: 40px 0 0;
	}

	ul {
		padding: 0;
	}

	a {
		color: #42b983;
	}

	* {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	#app {
		width: 100%;
		height: 100vh;
		padding-top: 1.5vh;
		padding-bottom: 1.5vh;
		padding-left: 1.2vw;
		padding-right: 1.2vw;
		background: url('../assets/bg.jpg') no-repeat;
		background-size: 100% 100%;
	}

	.top-input {
		width: 100%;
		height: 9.2vh;
		display: flex;
		justify-content: space-between;
		border-radius: 15px;
		padding: 0 0.83% 0 1.53%;
		background-color: #fff;
		align-items: center;
		box-shadow: 8px 14px 40px 0px rgba(162, 162, 162, 0.2);
	}

	.top-input-left {
		width: 1.79rem;
		height: 5vh;
		font-size: 0;
	}

	.top-input-left img {
		width: 100%;
		height: 100%;
	}

	.top-input-right {
		display: flex;
		flex: 1;
		height: 100%;
		margin-left: 30px;
		font-size: 0.34rem;
		font-weight: 500;
		color: #333333;
		overflow: hidden;
		align-items: center;


	}

	.top-input-right .marquee-box {
		display: flex;
		flex: 1;
		align-items: center;
	}

	.header-rightBtnBox {
		display: flex;

		height: 100%;
		margin-left: 1vw;
		justify-content: space-between;
		align-items: center;
		vertical-align: middle;
	}

	.header-rightBtnBox .btn-left {
		display: flex;
		align-items: center;

		height: 100%;
		padding: 0 18px;
	}

	.header-rightBtnBox .btn-left:hover {
		background-color: rgb(0, 0, 0, 0.025);
		cursor: pointer;
	}

	.header-rightBtnBox .btn-right {
		display: flex;
		align-items: center;

		height: 100%;
		padding: 0 18px;
	}

	.header-rightBtnBox .btn-right:hover {
		background-color: rgb(0, 0, 0, 0.025);
		cursor: pointer;
	}

	.header-rightBtnBox .btn-left img {
		width: 20px;
		height: 20px;

	}

	.header-rightBtnBox .btn-right img {
		width: 20px;
		height: 20px;

	}

	.top-input-right-text,
	.top-input-right-text-two {
		display: inline-block;
	}

	marquee {}

	.content-box {
		display: flex;
		height: 85vh;
		margin-top: 1.04%;
	}

	.content-box .content-left-box {
		width: 65%;
		margin-right: 1.3vw;
		height: 100%;
	}

	.content-left-top-box {
		width: 100%;
		height: 50.1vh;
		padding: 2.2vh 1.3vw;
		border-radius: 15px;
		background-color: #fff;
		box-shadow: 8px 14px 40px 0px rgba(162, 162, 162, 0.2);
	}

	.content-left-top-btn {
		display: flex;
		justify-content: center;
		font-size: 0.28rem;
		text-align: center;
		height: 13.5%;
		width: 100%;
		align-items: center;
		background: #f03291;
		border-radius: 15px;
		color: #fff;
	}

	.content-left-top-title {
		display: flex;
		font-size: 0.28rem;
		height: 15.5%;
		align-items: center;
		font-weight: 500;
		color: #f03291;
	}

	.content-left-top-title>div {
		flex: 1;
		text-align: center;
	}

	.content-left-top-userList-box {
		height: 70.5%;
		overflow: hidden;
	}

	/* .content-left-top-userList-box > div {
  flex: 1;
} */
	.content-left-top-userList {
		display: flex;
		align-items: center;
		height: 20%;
		font-size: 0.24rem;
	}

	.content-left-top-userList>div {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #333333;
	}

	.content-left-top-userList>div img {
		width: 0.5rem;
		height: 0.33rem;
		margin-right: 0.14rem;
	}

	.content-left-top-userList-listStyle {
		/* color: #4edb99; */
		list-style: none;
	}

	.content-left-top-userList-listStyle span {
		color: #333333;
	}

	.content-left-bottom-box {
		margin-top: 1.8vh;
		height: 33.1vh;
	}

	.content-left-bottom-box {
		display: flex;
	}

	.content-left-bottom-box .content-left-bottom-left {
		width: 40%;
		margin-right: 1.4%;
		padding: 1.1vh 1.1vw;
		background: #ffffff;
		box-shadow: 8px 14px 40px 0px rgba(162, 162, 162, 0.2);
		border-radius: 15px;
	}

	.content-left-bottom-right:last-child {
		flex: 1;
	}

	.content-left-bottom-left-btn,
	.content-left-bottom-right-btn {
		height: 17%;
		width: 100%;
		background: #f03291;
		border-radius: 15px;
		font-size: 0.24rem;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.content-left-bottom-left-title,
	.content-left-bottom-right-title {
		display: flex;
		font-size: 0.24rem;
		height: 17%;
		align-items: center;
		font-weight: 500;
		color: #f03291;
	}

	.content-left-bottom-left-title>div,
	.content-left-bottom-right-title>div {
		flex: 1;
		text-align: center;
	}

	.content-left-bottom-userListLeft-box {
		height: 65%;

		flex-direction: column;
		color: #333;
		overflow: hidden;
	}

	.content-left-bottom-userListLeft-box>div {
		/* flex: 1;
  display: flex;
  font-size: 0.28rem; */
	}

	.content-left-bottom-userListLeft>div {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.content-left-bottom-userListLeft-listStyle {
		/* color: #4edb99; */
		list-style: none;
	}

	.content-left-bottom-userListLeft-listStyle span {
		color: #333;
	}

	.content-left-bottom-right {
		background: #ffffff;
		box-shadow: 8px 14px 40px 0px rgba(162, 162, 162, 0.2);
		border-radius: 15px;
		padding: 1.3vh 1.3vw;
		font-size: 0.24rem;
	}

	.content-right-box {
		flex: 1;

		background: #ffffff;
		box-shadow: 8px 14px 40px 0px rgba(162, 162, 162, 0.2);
		border-radius: 15px;
		padding: 1vh 1.3vw;
	}

	.content-right-top {
		display: flex;
		justify-content: space-between;
	}

	.content-right-top>div {
		flex: 1;
	}

	.content-right-top-left {
		display: flex;
		flex-direction: column;
		align-items: left;
		justify-content: space-between;
		text-align: left;
	}

	.content-right-top-left .content-right-top-left-img {
		width: 89px;
		height: 50px;
		font-size: 0;
		overflow: hidden;
	}

	.content-right-top-left .content-right-top-left-img img {
		width: 100%;
		height: 100%;
		transform: translateX(-10%);
	}

	.content-right-top-left .content-right-top-left-text {
		margin-top: 0.24vh;
		font-size: 0.22rem;
		font-weight: 400;
		color: #333333;
	}

	.content-right-top-right {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-end;
	}

	.content-right-top-right-year {
		font-size: 0.4rem;
		height: 4.5vh;
		line-height: 6vh;
		font-weight: 500;
		color: #333333;
	}

	.content-right-top-right-time {
		margin-top: 0.24vh;
		font-size: 0.22rem;
		font-weight: 400;
		color: #333333;
	}

	.content-right-banner {
		margin-top: 1vh;

		width: 100%;
	}

	.content-right-banner img {
		height: 100%;
		width: 99%;
	}

	.content-right-banner video {
		height: 100%;
		width: 99%;
	}

	.content-right-banners {
		margin-top: 3vh;
		height: 100%;
		width: 100%;
	}

	.content-right-banners img {
		height: 100%;
		width: 100%;
	}

	.content-right-banners video {
		height: 100%;
		width: 100%;
	}

	.content-right-address {
		margin-top: 1.5vh;
		font-size: 0.24rem;
		font-weight: 700;
		color: #333;
	}

	.content-right-phoneNumber {
		margin-top: 1vh;
		font-size: 0.2rem;
		color: #333;
		font-weight: 400;
	}

	.content-right-erweima {

		z-index: 10;
		margin-top: 1vh;
		/* height: 21.3vh; */
		display: flex;
		justify-content: center;
	}

	.content-right-erweima img {
		width: 190px;
		height: 190px;
		z-index: 10;
	}

	.content-right-tops {
		margin-top: 1vh;
		font-size: 0.18rem;
		color: #333;
		text-align: center;
	}

	.blue {
		color: #5bb0e2;
	}

	.about {
		width: 100%;
		height: 100%;
	}

	.swiper-container {
		height: 100%;
		width: 100% !important;
	}

	.swiper-wrapper .swiper-slide {
		width: 100% !important;
		height: 100%;
		text-align: center;
		overflow: hidden;
		display: flex !important;
		justify-content: center !important;
	}

	.swiper-wrapper .swiper-slide img {
		width: 99% !important;
		height: 100%;
		/* object-fit: cover; */
	}

	.swiper-wrapper .swiper-slide video {
		width: 99% !important;
		object-fit: cover;
	}

	.bgcPink {
		background: rgba(240, 214, 228, 0.16);
	}

	.repairBox {
		width: 100%;
		height: 100%;
	}

	.waitBox,
	.helptBox {
		width: 100% !important;
		height: 100%;
	}

	.clearBox {
		width: 100% !important;
		height: 100%;
	}

	.waitBox>div {
		flex: 1;
		display: flex;
		font-size: 0.2rem;
		height: 25%;
	}

	.helptBox>div {
		flex: 1;
		display: flex;
		font-size: 0.2rem;
		height: 25%;
	}

	.clearBox>div {
		flex: 1;
		display: flex;
		font-size: 0.2rem;
		height: 25%;
	}

	.content-left-bottom-box .content-left-bottom-Two {
		width: 33%;
		margin-right: 1.4%;
	}

	.boxIcon {
		position: fixed;
		right: 0;
		bottom: 0;
		z-index: 9;
		width: 18.75%;
		height: 32.4%;
	}

	.content-right-banners .about {
		height: 27vh;
	}

	.content-right-erweimas {
		height: 23.3vh;
	}

	video {
		width: 100%;
		height: 100%;
		object-fit: fill;
	}

	.clickVideo {
		position: absolute;
		top: 2%;
		right: 2%;
		z-index: 0;
		width: 20px !important;
		height: 18px !important;
		cursor: pointer;
	}

	.el-message-box {
		width: 30vw !important;
		height: 20vh !important;
		border-radius: 15px !important;
	}

	.el-message-box__header {
		display: none;

	}

	.el-message-box__content {

		height: 50%;
		display: flex;
		align-items: center;
		justify-content: center;

	}

	.el-message-box__btns {
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 50%;
	}

	/* .el-message-box__title {
	height: 100%;
} */
	.el-message-box__content p {
		display: flex;


		font-size: 0.18rem;
		color: #333;
		height: 100%;
		align-items: center;
	}

	.el-message-box__content img {
		width: 0.26rem;
		margin-right: 5px;

	}

	.el-button {
		width: 50%;
		height: 50%;
		background-color: #f03291 !important;
		border: 0 !important;
		color: #fff;
		border-radius: 15px !important;
	}

	.el-button span {
		font-size: 0.24rem;
		color: #fff;
	}

	.modoleBox {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, .6);
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 32px;
		color: #fff;
		z-index: 9999;
	}

	.bigBox {
		width: 100%;
		text-align: center;
	}

	.pinktext {
		color: #f03291;
	}

	* {
		box-sizing: border-box;
	}

	.content-left-boxTwo {
		display: flex;
	}

	.content-left-boxTwo .content-left-top-box {
		width: 55%;
		height: 100%;
		margin-right: 2%;
	}

	.content-left-boxTwo .content-left-bottom-box {
		display: flex;
		flex: 1;
		height: 100%;
		margin-top: 0;
		flex-direction: column;
	}

	.content-left-boxTwo .content-left-bottom-box>div {
		width: 100%;

	}

	.content-left-boxTwo .content-left-bottom-box>div:first-child {
		height: 60%;
		margin-bottom: 4%;
	}

	.content-left-boxTwo .content-left-bottom-box>div:last-child {
		height: 36%;
	}

	.content-left-boxTwo .content-left-bottom-right {
		padding-top: 2.2vh;
	}

	.content-left-boxTwo .content-left-top-btn {
		height: 7.5%;
	}

	.content-left-boxTwo .content-left-top-title {
		height: 7.5%;
	}


	.content-left-boxTwo .content-left-bottom-Two .content-left-bottom-right-btn {
		height: 13%;
	}

	.content-left-boxTwo .content-left-bottom-Two .content-left-bottom-right-title {
		height: 13%;
	}

	.content-left-boxTwo .content-left-bottom-Two .content-left-bottom-userListLeft-box {
		height: 73%;
	}

	.content-left-boxTwo .content-left-bottom-right:last-child .content-left-bottom-right-btn {
		height: 20%;
	}

	.content-left-boxTwo .content-left-bottom-right:last-child .content-left-bottom-userListLeft-box {
		height: 77%;
	}

	.content-left-boxTwo .content-left-top-userList-box {
		height: 85%;
	}

	.content-left-boxTwo .content-left-top-userList {
		height: 10%;
	}

	.content-left-top-userList>div {
		width: 100%;
		max-height: 100%;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}

	.content-left-boxTwo .waitBox {
		display: flex;
		flex-wrap: wrap;
	}

	.content-left-boxTwo .waiUser-box {
		width: 50%;
		flex: none;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;


	}

	.content-left-boxTwo .waiUser-box>div {
		width: 100%;
		max-height: 100%;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}

	.content-left-boxTwo .waiUser-box-two {
		width: 33.33%;
	}

	.content-left-bottom-userListLeft>div>div {
		width: 100%;
		max-height: 100%;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
</style>